import './style.css';
import LOGO from 'assets/ActusIcone2025x1024.png';
import { useNavigate } from 'react-router-dom';

function HEADER({ children, className = '', showLogo = true }) {
  const navigate = useNavigate();

  return (
    <header className={`header ${className}`}>
      <div className="header-container">
        {/* Logo no canto esquerdo */}
        {showLogo && (
          <div className="header-logo">
            <img 
              src={LOGO} 
              alt="Actus Logo" 
              onClick={() => navigate('/')}
              className="logo-image"
              title="Ir para Home"
            />
          </div>
        )}
        
        {/* Conteúdo adicional (pode ser passado como children) */}
        {children && (
          <div className="header-content">
            {children}
          </div>
        )}
      </div>
    </header>
  );
}

export default HEADER;
